import { useFormik } from "formik";
import React, { useEffect } from "react";
import * as Yup from "yup";
import { useState } from "react";
import { Col, Modal, Row } from "react-bootstrap";
import TextInput from "../../common/textfield/TextInput";
import TextArea from "../../common/textfield/TextArea";
import { usePatientsBySOPQuery } from "../../../hooks/ReactQueryHooks/usePatientsBySOPQuery";
import { useScheduleCategoryQuery } from "../../../hooks/ReactQueryHooks/useScheduleCategoryQuery";
import SelectFiled from "../../common/textfield/SelectFiled";
import { Button } from "../../common/Button";
import { CircularProgress, Skeleton } from "@mui/material";
import { PickersDay } from '@mui/x-date-pickers/PickersDay';
import { DateSelectorWithoutFormik } from "../../common/textfield/DateSelector";
import moment from "moment";
import { checkSchedule, getSlots, rescheduleAppointment, getlistPractitioners } from "../api/AppointmentRequests";
import { getScheduleSlots, getSlotById, updateScheduleSlot} from "../../api/Schedule";
import { failed, success } from "../../common/Toastify";
import "../AppointmentRequests/style.css"
import { generatePass } from "../AppointmentRequests/Constants";
import { LOCATIONS } from "../../common/location";
import { useSelector } from "react-redux";
import { getSignature } from "../../Zoom/functions";
import { updateAppointmentRequest } from '../api/AppointmentRequests';
import { Form } from "react-bootstrap";
import { validation, conditionalValidation } from "../../../utils/constants";
import {
    computeServiceCategoryAvailabilities as buildScheduleServiceCategoryAvailabilities,
    filterSlotsForSelectedDay,
    getAvailableDayKeysForCategory,
    getDateKey,
    getScheduleDateOptions,
    mergeCategoryIdsByDay,
    mergeSlotsByStart,
    scheduleMatchesSelectedOrg,
    sortSlotsByStart
} from "../../../utils/ScheduleAvailabilitySupport";

const RescheduleAppointment = ({ modalShow, handleShow }) => {
    const user = useSelector((state) => state?.auth?.user);
    const [btnLoading, setBtnLoading] = useState(false);
    const [slotsLoading, setSlotsLoading] = useState(false);
    const [slotUnavailable, setSlotUnavailable] = useState(false);
    const [selectedSlot, setSelectedSlot] = useState("");
    const [serviceCategory, setServiceCategory] = useState([]);
    const [categoriesByDay, setCategoriesByDay] = useState({});
    const [reservedCategories, setReservedCategories] = useState ({})
    const [practitionersList, setPractitionersList] = useState([]);
    const [practitionerId, setPractitionerId] = useState(modalShow?.practitionerId);
    const [scopeOfPractice, setScopeOfPractice] = useState(null);
    const [availableSlots, setAvailableSlots] = useState([]);
    const [availableDays, setAvailableDays] = useState([]);
    const userOrg = useSelector((state) => state?.auth?.user?.organizations)
    /** Primary org for APIs: `modalShow.orgId` (set on appointment), then user default. */
    const bookingOrgId = modalShow?.orgId ?? userOrg?.[0]?.id;
    const preferredChannelType = modalShow?.intakeQuestions?.preferredChannel === "phone" || modalShow?.intakeQuestions?.preferredChannel === "Phone";
    const [fetchedSchedules, setFetchedSchedules] = useState([]);
    const [computedServiceCategories, setComputedServiceCategories] = useState({});
   /* 
    useScheduleCategoryQuery({
        onSuccess: (data) => setServiceCategory(data.map((item) => ({
            name: `${item?.name} (${item?.timeSlot?.value} min)`,
            value: item.id,
            id: item.id,
            timeSlot: item.timeSlot,
        }))),
        refetchOnWindowFocus: false
    })
    */ 
    const formik = useFormik({
        initialValues: {
            title: "",
            patient: "",
            // description: "",
            date: "",
            serviceCategory: "",
            availableSlot: "",
            preferredChannel: modalShow?.intakeQuestions?.preferredChannel,
            returnTelephoneNumber: modalShow?.intakeQuestions?.callerNumber,
            returnTelephoneNumberExt: modalShow?.intakeQuestions?.callerNumberExt,
            practitionerPreference: modalShow?.practitionerId ? "select practitioner" : "",
            practitioner: modalShow?.practitionerId,
        },
        validationSchema: Yup.object({
            title: conditionalValidation(
                Yup.string(),
                {
                    validation,
                    label: "Reason for Visit",
                    mandatory: true
                }),
            patient: conditionalValidation(
                Yup.string(),
                {
                    validation,
                    label: "Patient",
                    mandatory: true
                }),
            // description: Yup.string().required("Required Description field"),
            date: conditionalValidation(
                Yup.string(),
                {
                    validation,
                    label: "Date",
                    mandatory: true
                }),
            serviceCategory: conditionalValidation(
                Yup.string(),
                {
                    validation,
                    label: "Appointment Type",
                    mandatory: true
                }),
            practitioner: Yup.mixed().when(["practitionerPreference"], {
                is: (practitionerPreference) => practitionerPreference !== "no preference",
                then: Yup.string().required("Required Practitioner field."),
                otherwise: Yup.mixed().notRequired(),
            }),
            availableSlot: Yup.object().required("Required slots field"),
        }),
        onSubmit: (values) => {
            values.title = values.title?.trim();
            setBtnLoading(true);
            let slot = null;

            // let start =`${moment(values?.date)?.format("YYYY-MM-DD")}T${(values?.availableSlot?.start)}:00Z`;
            // let localStartTime = moment(start).format("HH:mm")
            // let localStart = `${moment(values?.date)?.format("YYYY-MM-DD")} ${(localStartTime)}`;
            // let utcStart = moment(localStart).utc().format("YYYY-MM-DDTHH:mm:ss[Z]")
            // let end = `${moment(values?.date)?.format("YYYY-MM-DD")}T${(values?.availableSlot?.end)}:00Z`;
            // let localEndTime = moment(end).format("HH:mm")
            // let localEnd = `${moment(values?.date)?.format("YYYY-MM-DD")} ${(localEndTime)}`;
            // let utcEnd = moment(localEnd).utc().format("YYYY-MM-DDTHH:mm:ss[Z]");
            let utcStart = values?.availableSlot?.start;
            let utcEnd = values?.availableSlot?.end;
            let reserved = values?.availableSlot?.status == "busy-reserved"
            let selectedServiceCategory = values?.serviceCategory;
            let intakeQuestions =modalShow?.intakeQuestions;
            intakeQuestions["preferredChannel"] = values?.preferredChannel;


            // if(selectedServiceCategory.endsWith("busyReserved")){
            //     selectedServiceCategory = selectedServiceCategory.split("-")?.[0];
            // }
            
            // this filter returns an object as a REFERENCE, so you need to structuredClone the resulting value if there is one
            selectedServiceCategory = serviceCategory?.filter((categoryData) => categoryData.value === selectedServiceCategory)?.[0]
            if (reserved && selectedServiceCategory) {
                selectedServiceCategory = structuredClone(selectedServiceCategory);
                selectedServiceCategory.id = selectedServiceCategory?.value?.split("-")[0];
                selectedServiceCategory.name = selectedServiceCategory.name.trim();
            }
            const slotSc = values?.availableSlot?.serviceCategory?.[0];
            const serviceCategoryCode =
                selectedServiceCategory?.id ||
                selectedServiceCategory?.value ||
                slotSc?.id ||
                slotSc?.coding?.[0]?.code ||
                selectedServiceCategory?.coding?.[0]?.code;
            const serviceCategoryDisplay =
                selectedServiceCategory?.display ||
                selectedServiceCategory?.name ||
                slotSc?.name ||
                slotSc?.coding?.[0]?.display;
            let serviceCategoryPayload = [
                {
                  coding: [
                    {
                      system: "http://florizel.com/AppointmentServiceCategory",
                      code: serviceCategoryCode,
                      display: serviceCategoryDisplay
                    }
                  ],
                  text: `Appointment for ${serviceCategoryDisplay}`
                }
            ]
            /* if(values?.availableSlot.status === "busy-reserved"){
                utcStart= values?.availableSlot?.start
                utcEnd = values?.availableSlot?.end
                slot = values?.availableSlot;
            }
            else */ if(formik?.values?.practitionerPreference === "no preference") {
                values.practitioner = values?.availableSlot?.actorId;
                values.scheduleId = values?.availableSlot?.scheduleId;
            }
            else values.scheduleId = values?.availableSlot?.scheduleId;
            
            const requestedPeriod = [{start: utcStart, end: utcEnd}];
            let keepOldSlot = false;
            getSlotById(modalShow?.slotId)
            .then((response) =>{
            let data = response?.data?.[0]
            // if(data?.serviceCategory?.[0]?.id){
            //     keepOldSlot = true;
            // }
            rescheduleAppointment({serviceCategory: serviceCategoryPayload, intakeQuestions, keepOldSlot: false, slot,  appointmentId: modalShow?.id,  requestedPeriod , practitionerId:  values?.practitioner, scheduleId: values?.scheduleId, description: values?.title, orgId: bookingOrgId })
                .then((res) => {
                    success("Appointment Rescheduled");
                    if(keepOldSlot){
                        updateScheduleSlot({
                            slotId : data?.id,
                            start: data?.start,
                            end: data?.end,
                            status: "busy-reserved",
                            serviceCategory: data?.serviceCategory,
                            orgId: bookingOrgId,
                        })
                        .catch(()=>{})
                    }
                    handleShow();

                })
                .catch((res) => failed(res?.response?.data?.message || res?.response?.data?.error || res.message))
                .finally(() => setBtnLoading(false));
            })
            
            .catch(() => {})
        },
    });
    
    useEffect(() => {
        if (modalShow?.id) {
            formik.setFieldValue("title",  modalShow.description);
            formik.setFieldValue("patient", modalShow.participant?.filter((data) => data?.actor?.type === "Patient")?.[0]?.actor?.display) ;
            formik.setFieldValue("description", modalShow.comment || "");
            formik.setFieldValue("returnTelephoneNumber", modalShow?.intakeQuestions?.callerNumber || "");
            formik.setFieldValue("returnTelephoneNumberExt", modalShow?.intakeQuestions?.callerNumberExt || "");
            formik.setFieldValue("practitioner", modalShow?.practitionerId || "");
            setPractitionerId(modalShow?.practitionerId || null);
            formik.setFieldValue("preferredChannel", modalShow?.intakeQuestions?.preferredChannel || "");           
        }
    }, [modalShow])

    useEffect(() => {
        if (!modalShow?.id || !bookingOrgId) return;
        let scope;
        try {
            if (modalShow?.patientLocation) {
                scope = modalShow.patientLocation;
            } else {
                const locTag = modalShow?.intakeQuestions?.filter((el) => el.tag === "LOCATION")?.[0];
                const selected = locTag?.answer?.find((val) => val.answer?.length > 0);
                const raw = selected?.answer;
                scope = raw ? (LOCATIONS[raw] ?? raw) : null;
            }
        } catch {
            return;
        }
        if (!scope) return;
        setScopeOfPractice(scope);

        getlistPractitioners({ orgId: bookingOrgId, scopeOfPractice: scope })
            .then(async (res) => {
                let allPracts = res.result?.filter((pra) => pra.active);
                let activePractitioners = [];
                let startDate =
                    formik?.values?.date?.length > 0 ? moment(formik?.values?.date) : moment();
                startDate = moment(startDate).utc().format("YYYY-MM-DDTHH:mm:ss") + "Z";

                await checkSchedule({
                    actorId: user["custom:unique_id"],
                    date: startDate,
                    orgId: bookingOrgId,
                })
                    .then((activeSchedules) => {
                        if (!activeSchedules?.data) {
                            failed(activeSchedules?.message);
                            setServiceCategory([]);
                            setCategoriesByDay({});
                            setPractitionersList([]);
                            return;
                        }
                        if (!Array.isArray(activeSchedules.data))
                            activeSchedules.data = [activeSchedules.data];

                        activeSchedules.data = activeSchedules.data.filter((sch) => {
                            if (!scheduleMatchesSelectedOrg(sch, bookingOrgId)) return false;
                            if (!sch.serviceCategory?.length) return false;
                            return sch.serviceCategory.some((cat) =>
                                moment.utc(cat.date).isSameOrAfter(moment.utc(startDate).startOf('day'))
                            );
                        });

                        activeSchedules.data.forEach((schedule) => {
                            let active = allPracts.find(
                                (person) =>
                                    person.id === schedule.actorId &&
                                    !activePractitioners.some((exists) => exists.id === schedule.actorId)
                            );
                            if (active) activePractitioners.push(active);
                        });
                        setPractitionersList(
                            activePractitioners.map((ele) => ({
                                value: ele?.id,
                                name: ele?.name?.[0]?.text
                                    ?.split(" ")
                                    .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
                                    .join(" "),
                                id: ele?.id,
                                orgId:
                                    ele?.orgId ??
                                    ele?.managingOrganization?.[0]?.reference?.split("/")?.[1],
                            }))
                        );
                    })
                    .catch((activeSchedules) => {
                        failed(
                            activeSchedules?.response?.data?.message ||
                                activeSchedules?.response?.data?.error ||
                                activeSchedules.message
                        );
                        setServiceCategory([]);
                        setCategoriesByDay({});
                        setPractitionersList([]);
                    });
            })
            .catch((res) => {
                failed(res?.response?.data?.message || res?.response?.data?.error || res.message);
            });
    }, [modalShow, bookingOrgId]);
   
    
    useEffect(() => {
        let startLocal = (formik?.values?.date?.length > 0) ? moment(formik?.values?.date) : moment();
        let startDate = moment(startLocal).utc().format("YYYY-MM-DDTHH:mm:ss") + "Z";
        let start = startLocal.format("YYYY-MM-DD");
        if(formik?.values?.practitionerPreference &&
            ((formik?.values?.practitionerPreference === "select practitioner" && practitionerId)
               || formik?.values?.practitionerPreference === "no preference" )){
                checkSchedule({ actorId: formik?.values?.practitionerPreference === "no preference" ? user["custom:unique_id"] : practitionerId, date: startDate, orgId: formik?.values?.practitionerPreference === "no preference" ? bookingOrgId : null }) 
            .then((res) => { 
                if(!res?.data) {
                   failed(res?.message);
                   setServiceCategory([]);
                   setCategoriesByDay({});
                   return;
                }
                
                let categories = [];
                if (!Array.isArray(res.data)) res.data = [res.data];
                
                res.data = res.data.filter(sch => scheduleMatchesSelectedOrg(sch, bookingOrgId))
                setFetchedSchedules(res.data);
                let tempByDay = {};
                res.data.forEach(schedule => {                
                    schedule.serviceCategory.forEach(category => {
                        if(category.id) { // occasional bad data where there is a date and no id, so do not process
                            let key = moment.utc(category?.date).format("YYYY-MM-DD");
                            let catMoment = moment.utc(category?.date);
                            if(catMoment.isSameOrAfter(moment.utc(startDate).startOf('day')) && 
                                !categories.some(item => item.value === category.id)) {
                                categories.push({...category, value: category?.id});                                
                            }
                            if(catMoment.isSameOrAfter(moment.utc(startDate).startOf('day'))) {
                                if(tempByDay[key]) {
                                    if(!tempByDay[key].some(id => id === category.id )) 
                                        tempByDay[key].push(category.id)
                                    }
                                else tempByDay[key] = [category.id];   
                            }
                        }
                    })
                
            })
            setCategoriesByDay((prev) => mergeCategoryIdsByDay(prev, tempByDay))
            let reservedSlots ={}
            res.data.forEach(schedule => 
                getScheduleSlots(schedule.id, "busy-reserved", bookingOrgId)
                .then((resp) => {
                    (resp.data || [])
                    ?.forEach((slot) => {
                        slot.serviceCategory?.forEach(cat => {
                            let serviceCategoryId = cat.id || cat.coding[0].code;
                            let categoryDate = schedule.serviceCategory?.find(item => item.id === serviceCategoryId)?.date;
                            if (getDateKey(slot?.start, getScheduleDateOptions(categoryDate)) < start) return;
                            if (reservedSlots.hasOwnProperty(serviceCategoryId)) {
                                reservedSlots[serviceCategoryId].push({
                                    "start": slot?.start,
                                    "end": slot?.end,
                                    "serviceCategory": [cat],
                                    "categoryDate": categoryDate,
                                    "scheduleId": slot?.scheduleId,
                                    "actorId": schedule.actorId,
                                    "orgId": slot?.orgId,
                                    "status": "busy-reserved"
                                });
                            }    
                            else {
                                reservedSlots[serviceCategoryId] = [{
                                    "start": slot?.start,
                                    "end": slot?.end,
                                    "serviceCategory": [cat],
                                    "categoryDate": categoryDate,
                                    "scheduleId": slot?.scheduleId,
                                    "actorId": schedule.actorId,
                                    "orgId": slot?.orgId,
                                    "status": "busy-reserved"
                                }];
                            }
                        })
                    })
                    Object.keys(reservedSlots).forEach(key => {
                        if(reservedSlots[key].length > 0 
                            && (reservedSlots[key][0]?.serviceCategory?.[0]?.id || reservedSlots[key][0]?.serviceCategory?.[0].coding[0]?.code)) {
                            if(getDateKey(reservedSlots[key][0]?.start) >= start &&
                                !categories.some(item => item.value === key)) {
                                let timeSlot = reservedSlots[key][0]?.serviceCategory?.[0]?.timeSlot;
                                if(!timeSlot) {
                                    let timeSlotString = reservedSlots[key]?.[0]?.serviceCategory[0]?.coding[0]?.display.split("(")[1].split(")")[0].split(" ");
                                    timeSlot = { 
                                        value: parseInt(timeSlotString[0]),
                                        unit: 'minutes'
                                    };
                                }
                                let name = `${formik.values.practitioner.length > 0 ? "Reserved for " :"" } ${reservedSlots[key]?.[0]?.serviceCategory[0]?.name || reservedSlots[key]?.[0]?.serviceCategory[0]?.coding[0]?.display}`;
                                let value = (reservedSlots[key][0]?.serviceCategory?.[0]?.id || reservedSlots[key][0]?.serviceCategory?.[0].coding[0]?.code);
                                categories.push({
                                    name, 
                                    value,
                                    id: value,
                                    timeSlot,
                                    orgId: reservedSlots[key][0].orgId,
                                    date: reservedSlots[key][0]?.categoryDate || reservedSlots[key][0]?.start
                                })
                            }
                            tempByDay = {};
                            if(reservedSlots[key].length > 0) {
                                reservedSlots[key].forEach(slot => {
                                    let datekey = getDateKey(slot?.start);
                                    
                                    if(datekey && datekey >= start) {
                                        if(tempByDay[datekey] && !tempByDay[datekey]?.some(id => id === key)) {
                                                tempByDay[datekey].push(key);
                                        }
                                        else tempByDay[datekey] = [key];
                                    }
                                })
                            }
                            setCategoriesByDay((prev) => mergeCategoryIdsByDay(prev, tempByDay)) 
                        }
                    });
                    setReservedCategories(reservedSlots);
                    setServiceCategory([...categories])
                })
                .catch((res) => {
                    failed(res?.response?.data?.message || res?.response?.data?.error || res.message);
                        setServiceCategory([]);
                        setCategoriesByDay({});
                    })
                );
            })
            .catch((res) => {
                failed(res?.response?.data?.message || res?.response?.data?.error || res.message);
                setServiceCategory([]);
                setCategoriesByDay({});
            });
        }
    }, [modalShow?.id, formik?.values?.practitioner, formik?.values?.practitionerPreference, practitionerId, bookingOrgId])


    const loadSlotData = (selectedDate, selectedType) => {
        setSlotsLoading(true);
        setSlotUnavailable(false);
        let today = new Date();
        const date = moment(selectedDate || formik?.values?.date);
        let type = (selectedType) ? selectedType : formik?.values?.serviceCategory;
        const selectedDayKey = date.format("YYYY-MM-DD");
        const dateUtc = moment(date).utc().format("YYYY-MM-DDTHH:mm:ss") + "Z";
        const selectedCategory = serviceCategory.find(
            (item) => (item.id || item.value) === type || item.value === `${type}-busyReserved`
        );
        const scheduleDateOptions = getScheduleDateOptions(selectedCategory?.date);

        if (!type) {
            setSlotsLoading(false);
            return;
        }

        let slots = reservedCategories[type] || [];
        slots = filterSlotsForSelectedDay(slots, selectedDayKey, {
            now: today,
            options: scheduleDateOptions,
        });
        slots = sortedSlots(slots);

        const slotsActorId = practitionerId || formik?.values?.practitioner || user["custom:unique_id"];
        const practitionerEntry = practitionersList.find(
            (p) => p.id === slotsActorId || p.value === slotsActorId
        );
        const slotsOrgId = [
            practitionerEntry?.orgId,
            modalShow?.orgId,
            modalShow?.serviceProvider?.reference?.split("/")?.[1],
            modalShow?.managingOrganization?.reference?.split("/")?.[1],
            modalShow?.managingOrganization?.[0]?.reference?.split("/")?.[1],
            bookingOrgId,
            userOrg?.[0]?.id,
        ].find((id) => id !== undefined && id !== null && String(id).trim() !== "");

        let params = { actorId: slotsActorId, date: dateUtc, serviceCategoryId: type, orgId: slotsOrgId };
        if (formik?.values?.practitionerPreference === "no preference") {
            if (scopeOfPractice) {
                params.scopeOfPractice = scopeOfPractice;
            } else if (modalShow?.patientLocation) {
                params.scopeOfPractice = modalShow.patientLocation;
            } else {
                const locTag = modalShow?.intakeQuestions?.filter((el) => el.tag === "LOCATION")?.[0];
                const selected = locTag?.answer?.find((val) => val.answer?.length > 0);
                const raw = selected?.answer;
                if (raw) {
                    const mapped = LOCATIONS[raw] ?? raw;
                    setScopeOfPractice(mapped);
                    params.scopeOfPractice = mapped;
                }
            }
        }

        getSlots(params)
            .then((res) => {
                const currentSlots = mergeSlotsByStart(
                    filterSlotsForSelectedDay(res?.data?.availableSlots || [], selectedDayKey, {
                        now: today,
                        options: scheduleDateOptions,
                    }),
                    slots
                );
                setAvailableSlots(currentSlots);
                if (currentSlots.length < 1) {
                    setSlotUnavailable(true);
                }
            })
            .catch((res) => {
                if (slots?.length > 0) {
                    setAvailableSlots(sortedSlots(slots));
                } else {
                    failed(res?.response?.data?.message || res?.response?.data?.error || res.message);
                    setAvailableSlots([]);
                }
            })
            .finally(() => {
                setSlotsLoading(false);
            });
    }; 

    const handleDateSelection = (val) => {
        const isValidDate = moment(val, 'MMM-DD-YYYY').isValid()
        setAvailableSlots([])
        if(isValidDate){
            formik.setFieldValue("date", val.format("YYYY-MM-DD"));
            // load slots here
            loadSlotData(val.format("YYYY-MM-DD"))
        }else{
            formik.setFieldError('date', 'Invalid date format')
        }       
    }    

    /** sorts slots based on time */
    const sortedSlots = (data) => {      
        return sortSlotsByStart(data);
    }

    const sortedObj = data => {
        return data.sort((a,b) => {
            return a.name > b.name ? 1 : -1
        });
    }

    const findUpcoming = (event) => {
        setSlotUnavailable(false);        
        let targetVal = event?.target?.value;
        formik.setFieldValue("serviceCategory", targetVal);
        setAvailableSlots([])
        formik.setFieldValue("date", "");
        setSelectedSlot("");
        formik.setFieldValue("availableSlot", "");
        highLightDates();
    }

    const renderDay = (props) => {
        const { selectedDate, day, dayComponent, ...other} = props;
        const today = moment().startOf('day');
        const isAvailable = availableDays.includes(day.clone().format("YYYY-MM-DD"));
        const isSelected = day.isSame(selectedDate, "day");
        const isToday = day.clone().isSame(today, "day");
        const isPast = day.clone().isBefore(today, "day")

        return (
            <PickersDay {...dayComponent} 
                disabled={isPast || !isAvailable}
                style={isAvailable ? {background: "#accfeb"}: {background: "white" }} />
        );
    }

    const handlePractitionerPreferenceChange = (e) => {
        setPractitionerId(null);
        formik.setFieldValue("practitioner", "");
        formik.setFieldValue("serviceCategory", ""); 
        formik.setFieldValue("date", "");
        setServiceCategory([]);
        setAvailableSlots([]);
        setCategoriesByDay({});
        formik.setFieldValue("practitionerPreference", e.target.id);
    };
    
    const handlePractitionerChange = (event) => {   
        setPractitionerId(event?.target?.value);
        formik.setFieldValue("practitioner", formik?.values?.practitionerPreference === "no preference" ? "" : event?.target?.value );
        formik.setFieldValue("serviceCategory", ""); 
        formik.setFieldValue("date", "");
        setServiceCategory([]);
        setAvailableSlots([]);
        setCategoriesByDay({});
    }


    const highLightDates = () => {
        const selectedCategory = serviceCategory.find(
            (item) => (item.id || item.value) === formik.values.serviceCategory
        );
        setAvailableDays(getAvailableDayKeysForCategory({
            serviceCategories: serviceCategory,
            selectedServiceCategoryId: formik.values.serviceCategory,
            availabilityByCategory: computedServiceCategories,
            options: getScheduleDateOptions(selectedCategory?.date),
        }));
    };


    const fetchSchedules = async () => {
        const schedulesWithSlots = await Promise.all(
            fetchedSchedules.map(async (schedule) => {
            const slotsResponse = await getScheduleSlots(schedule.id, null, bookingOrgId);
            const slots = slotsResponse.data || [];
            return { ...schedule, slots };
            })
        );

        const result = computeServiceCategoryAvailabilities(schedulesWithSlots);
        setComputedServiceCategories(result);
    };


    const computeServiceCategoryAvailabilities = (schedules) => buildScheduleServiceCategoryAvailabilities(schedules);

    useEffect(() => {
        if(fetchedSchedules.length > 0 && formik?.values?.practitionerPreference) {
            fetchSchedules()
        }
    }, [fetchedSchedules, formik?.values?.practitionerPreference, bookingOrgId]);

    useEffect(() => {
        if (formik.values.serviceCategory && Object.keys(computedServiceCategories).length > 0) {
            highLightDates();
        }
    }, [computedServiceCategories, formik.values.serviceCategory]);
    return (
        <Modal
            backdropClassName
            backdrop={'static'}
            size="xl" show={modalShow} onHide={handleShow}
            aria-labelledby="contained-modal-title-vcenter"
            centered className="custom-dialog">
            <Modal.Header closeButton className="border-0">
                <Modal.Title id="contained-modal-title-vcenter">
                    Rescheduling Appointment
                </Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <form className="common-form border-fields" onSubmit={formik.handleSubmit}>
                    
                    <>
                        <Row>
                            <Col>
                                <TextInput keyField={"title"} label={"Reason for visit"} formik={formik} placeholder={"Reason for visit"} />
                            </Col>
                            <Col>
                                <TextInput disabled = {true} keyField={"patient"} label={"Patient Name"} formik={formik} placeholder={"Patient Name"} style={{textTransform: "capitalize"}}/>
                            </Col>
                        </Row>
                        <Row>
                            <Col>
                                <Form.Check.Label style={{ textTransform: "capitalize", fontSize: "14px" }} >{"practitioner preference ?"}</Form.Check.Label> <span className="requiredField">&#42;</span><br/>
                                {["select practitioner", "no preference"].map((val) => (
                                    <Form.Check style={{ textTransform: "capitalize", fontSize: "14px", marginRight: "45px"}} inline checked={formik.values.practitionerPreference === val} type={"radio"} label={val} id={val} name="practitioner preference"  onChange={handlePractitionerPreferenceChange} />
                                    ))}
                                    {formik?.touched["practitionerPreference"] && formik?.errors["practitionerPreference"] ? (<div className="error-text">{formik?.errors["practitionerPreference"]} </div>) : null}
                            </Col>
                            {formik?.values?.practitionerPreference === "select practitioner" ? (
                                <Col>
                                    <SelectFiled keyField={"practitioner"} label={"Select Practitioner"} formik={formik} options={sortedObj(practitionersList)} onChange={handlePractitionerChange} />
                                </Col>
                            ) : <Col></Col>}
                                
                        </Row>
                        <Row className="mt-3">
                            <Col>
                                <SelectFiled keyField={"serviceCategory"} label={"Appointment Type"} formik={formik} options={sortedObj(serviceCategory)} disabled={!formik.values.practitionerPreference} onChange={findUpcoming} />
                            </Col>
                            <Col>
                                <DateSelectorWithoutFormik disabled={!formik?.values?.serviceCategory} formik={formik} keyField={'date'} label="Date" value={(formik?.values?.date?.length > 0) ? moment(formik?.values?.date) : null} handleChange={(value) => { handleDateSelection(value)}} minDate={moment()} defaultValue={moment()} onMonthChange={highLightDates} onOpen={highLightDates} renderDay={(day, selectedDate, dayComponent) => renderDay({day, selectedDate, dayComponent})} />
                            </Col>
                        </Row>
                        {availableSlots?.length > 0 ?
                                <>
                                    <Row>
                                        <Col>Select Slot</Col>
                                    </Row>
                                    <Row style={{/*  justifyContent: "center", */ rowGap: "0.5rem", marginBottom: "1.5rem", marginTop: "0.5rem" }}>
                                        {availableSlots?.map((slot, index) => {
                                        let localTime = moment(slot?.start).format("HH:mm");
                                        
                                        return ( <Col style={{ background: selectedSlot === slot?.start ? "#6c757d38" : "#ffff", width: "14.666667%" }} sm={2} className="slotStyle" key={index} onClick={() => { formik?.setFieldValue("availableSlot", slot); setSelectedSlot(slot?.start) }}>{localTime}</Col>)
                                        })}
                                    </Row>
                                </>
                                : null}
                        {slotsLoading ?
                            <>
                                <Row>
                                    <Col>Select Slot</Col>
                                </Row>
                                <Skeleton height={50} />
                            </>
                            : null}
                        <Row>
                            {/* <Col>
                                <TextArea keyField={"description"} label={"Description"} formik={formik} placeholder={"Description"} />
                            </Col> */}
                            {modalShow?.intakeQuestions?.preferredChannel && (
                              <Col>
                                <Form.Check.Label style={{ textTransform: "capitalize", fontSize: "14px" }} >{"preferred channel ?"}</Form.Check.Label> <span className="requiredField">&#42;</span><br/>
                                {["phone", "video/chat"].map((val) => (
                                    <Form.Check style={{ textTransform: "capitalize", fontSize: "14px", marginRight: "65px"}} inline checked={formik.values.preferredChannel === val} type={"radio"} label={val} id={val} name="preferred channel" onChange={e => formik.setFieldValue("preferredChannel", e.target.id)} />
                                ))}
                            </Col>  
                            )}
                            
                            {modalShow?.intakeQuestions?.callerNumber && (
                              <Col>
                                <Row>
                                    <Col>
                                        <TextInput keyField={"returnTelephoneNumber"} type="phone" label={"Return Telephone Number"} formik={formik} disabled={true} placeholder={"Return Telephone Number"} required={true} />
                                    </Col>
                                    <Col>
                                        <TextInput keyField={"returnTelephoneNumberExt"} label={"Ext."} formik={formik} disabled={true} placeholder={"Ext."} required={false} />
                                    </Col>
                                </Row>
                            </Col>  
                            )}
                        </Row>
                    </>
                    
                    <div className="btn-wrap">
                        <Button
                            onClick={() => {
                                handleShow();
                            }}
                            variant="secondary"
                            title="Cancel"
                        >
                            Cancel
                        </Button>
                        <Button type="submit" isLoading={btnLoading}>
                            Done
                        </Button>
                    </div>
                </form>
            </Modal.Body>
        </Modal>
    );
};

export default RescheduleAppointment;
